import { render, staticRenderFns } from "./SwitchItem.vue?vue&type=template&id=ac86506a&scoped=true&"
import script from "./SwitchItem.vue?vue&type=script&lang=js&"
export * from "./SwitchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac86506a",
  null
  
)

export default component.exports